<template>
  <div
    class="flex flex-col mt-24 max-w-xs md:flex-row md:mt-80 md:max-w-screen-md"
  >
    <div class="flex items-center md:flex-col md:basis-1/2">
      <h1 class="sr-only">Error 404</h1>
      <NuxtImg
        src="/shop/images/404/rotated-sad-smiley.svg"
        class="w-[121px] h-[131px]"
        alt=""
        loading="lazy"
      />
    </div>
    <div class="flex items-center mt-32 basis-1/2 md:flex-col">
      <div class="flex flex-wrap items-center justify-center md:justify-normal">
        <h5 class="font-medium text-28-28 py-16">Oops! Något gick fel!</h5>
        <AppButton size="sm" type="secondary" href="/">
          Gå till startsidan
        </AppButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>
